import { render, staticRenderFns } from "./SpeedInsights.vue?vue&type=template&id=3f05b7b2&scoped=true&"
import script from "./SpeedInsights.vue?vue&type=script&lang=js&"
export * from "./SpeedInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05b7b2",
  null
  
)

export default component.exports